import React from "react";
import WorkspaceInternalControls from "../libraries/WorkspaceInternalControls";

interface ImpairmentInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function ImpairmentInternalControls({ onBack, setActiveSection, controlsListSection }: ImpairmentInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Impairment Testing"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}


